const errors = new Map();
const errorsObject = Object.fromEntries(errors);
export const drawflowDefault = {
  drawflow: {
    Home: {
      data: {
        36: {
          id: 36,
          name: 'Flow',
          data: {
            type: 'FLOW',
            name: 'Flujo conversacional',
            description:
              'Un flujo diseñado para interactuar con los clientes, optimizando la comunicación y facilitando la gestión de consultas',
            message: '',
            startmessage: 'No entiendo tu consulta, ingresa un hola para iniciar.',
            understandmessage:
              'Lo siento, no he entendido bien tu solicitud. Por favor, elige una opción para continuar.',
            completed: true,
            isExpanded: true,
            entryType: '',
            triggerwords: 'hola',
            errors: errorsObject,
            shadow: false,
            hastemplate: false,
            idroomtemplate: '',
            postreply: '',
            enablepostreply: false,
          },
          class: 'beplic-node',
          html: `<div class="header-container"><i class="fas fa-project-diagram header-icon"></i><p class="header-text">flujo</p><span id="toggleIcon" class="expand-icon">-</span></div><div id="body-container" class="card"><div class="card-body"><h6 class="mb-3">Comienza a configurar el flujo de conversación</h6><label class="form-label">Nombre del flujo *</label><input type="text" id="flowName" class="form-input" minlength="10" maxlength="100" df-name><span id="flowNameError" class="error-message"></span><span id="flowNameCounter" class="character-counter" data-for="flowName"></span><label class="form-label">Descripción del flujo</label><textarea name="flowDescription" class="w-100" rows="4" minlength="5" maxlength="250" df-description id="flowDescription"></textarea><span id="flowDescriptionCounter" class="character-counter" data-for="flowDescription"></span><div class="label-with-tooltip"><label class="form-label">Palabras para iniciar el flujo*</label><span class="tooltip-icon" data-tooltip="Escribe palabras claves que iniciarán el flujo. Si decides poner más de una palabra sepáralas por comas."><i class="fas fa-info-circle icon-spaced marg"></i></span></div><input placeholder="hola, hello, buen día" type="text" id="triggerWords" class="form-input" minlength="10" maxlength="250" df-triggerwords><span id="triggerWordsError" class="error-message"></span><span id="triggerWordsCounter" class="character-counter" data-for="triggerWords"></span><div class="label-with-tooltip" style="display: flex; align-items: center;"><label class="form-label" style="margin: 0;">Modo oculto</label><span class="tooltip-icon" style="position: relative; margin-left: 6px; top: -8px;" data-tooltip="El flujo permanece oculto hasta que escriban las palabras claves. No muestra el mensaje de inicio ni aparece entre las opciones en salas con varios flujos."><i class="fas fa-info-circle"></i></span><input type="checkbox" class="form-checkbox" df-shadow style="margin-left: 25px;"></div><div class="label-with-tooltip"><label class="form-label">Mensaje de inicio personalizado *</label><span class="tooltip-icon" data-tooltip="Personaliza el mensaje para iniciar el flujo. Ten en cuenta incluir alguna de las palabras claves que definiste en el campo anterior"><i class="fas fa-info-circle icon-spaced marg"></i></span></div><div style="position: relative;"><textarea id="startMessage" class="w-100" rows="4" minlength="10" maxlength="250" df-startmessage></textarea><button type="button" class="emoji-toggle emoji-button"><i class="far fa-smile" style="font-size: 20px; pointer-events: none;"></i></button></div><span id="startMessageError" class="error-message"></span><span id="startMessageCounter" class="character-counter" data-for="startMessage"></span><div class="label-with-tooltip"><label class="form-label">Mensaje de respuesta no comprendida *</label><span class="tooltip-icon" data-tooltip="Personaliza el mensaje a mostrar cuando el bot no comprende una consulta"><i class="fas fa-info-circle icon-spaced marg"></i></span></div><div style="position: relative;"><textarea id="understandmessage" class="w-100" rows="4" minlength="10" maxlength="250" df-understandmessage></textarea><button type="button" class="emoji-toggle emoji-button"><i class="far fa-smile" style="font-size: 20px; pointer-events: none;"></i></button></div><span id="understandmessageError" class="error-message"></span><span id="understandmessageCounter" class="character-counter" data-for="understandmessage"></span><p class="mt-3">Componente completado <i id="completionIcon" class="fas fa-check-circle fa-lg icon-spaced"></i></p></div></div>`,
          typenode: false,
          inputs: {},
          outputs: {
            output_1: {
              connections: [
                {
                  node: '37',
                  output: 'input_1',
                },
              ],
            },
          },
          pos_x: -144,
          pos_y: 59,
        },
        37: {
          id: 37,
          name: 'Presentation',
          data: {
            type: 'presentation',
            name: 'Presentación',
            message: '¡Hola! Soy el asistente virtual.',
            completed: true,
            isExpanded: true,
            entryType: '',
          },
          class: 'beplic-node',
          html: '\n    <div class="header-container">\n        <i class="fas fa-project-diagram header-icon"></i> \n        <p class="header-text">Presentación</p>\n        <span id="toggleIcon" class="expand-icon">-</span>\n    </div>\n    <div id="body-container" class="card">\n        <div class="card-body">\n            <h6 class="mb-3">Configura un saludo inicial y presentación</h6>\n            \n            <!-- Nombre componente presentación -->\n            <label class="form-label">Nombre del componente presentación *</label>\n            <input type="text" id="presentationName" class="form-input" minlength="3" maxlength="100" df-name>            \n            <span id="presentationNameError" class="error-message"></span>\n            <span id="presentationNameCounter" class="character-counter" data-for="presentationName"></span>\n            \n            <!-- Mensaje presentación -->            \n            <label class="form-label">Mensaje de presentación *</label>               \n            <div style="position: relative;">\n                <textarea name="presentationMessage" class="w-100" rows="5" minlength="3" maxlength="300" df-message id="presentationMessage"></textarea>\n<button type="button" class="emoji-toggle emoji-button"><i class="far fa-smile" style="font-size: 20px; pointer-events: none;"></i></button> \n            </div>\n            <span id="presentationMessageError" class="error-message"></span>\n            <span id="presentationMessageCounter" class="character-counter" data-for="presentationMessage"></span>\n            \n            <p class="mt-3">Componente completado <i id="completionIcon" class="fas fa-check-circle fa-lg icon-spaced"></i></p>\n        </div>\n    </div>\n',
          typenode: false,
          inputs: {
            input_1: {
              connections: [
                {
                  node: '36',
                  input: 'output_1',
                },
              ],
            },
          },
          outputs: {
            output_1: {
              connections: [
                {
                  node: '38',
                  output: 'input_1',
                },
              ],
            },
          },
          pos_x: 265,
          pos_y: 108,
        },
        38: {
          id: 38,
          name: 'RequiredData',
          data: {
            type: 'REQUIREDDATA',
            name: 'datos requeridos',
            namemessage: '¿Puedes indicar tu nombre?',
            numbermessage: 'Ahora, cuál es tu número de teléfono?',
            emailmessage: 'Por último, cuál es tu correo electrónico ?',
            completed: true,
            isExpanded: true,
            entryType: '',
          },
          class: 'beplic-node',
          html: '\n<div class="header-container">\n <i class="fa fa-asterisk header-icon"></i> <p class="header-text">datos requeridos</p>\n <span id="toggleIcon" class="expand-icon">-</span>\n</div>\n<div id="body-container" class="card">\n <div class="card-body">\n  <h6 class="mb-3">Configura los datos requeridos a solicitar a tus clientes</h6>\n  \n  <!-- Mensaje para solicitar el nombre -->\n  <label class="form-label">Mensaje para solicitar el <b>nombre</b> *</label>\n  <div style="position: relative;">\n    <textarea name="Text1" class="w-100" rows="4" minlength="3" maxlength="350" df-namemessage id="nameRequestMessage"></textarea>\n<button type="button" class="emoji-toggle emoji-button"><i class="far fa-smile" style="font-size: 20px; pointer-events: none;"></i></button>\n  </div>\n  <span id="nameRequestMessageError" class="error-message"></span>\n  <span id="nameRequestMessageCounter" class="character-counter" data-for="nameRequestMessage"></span>\n  \n  <!-- Mensaje para solicitar el teléfono -->\n  <label class="form-label">Mensaje para solicitar el <b>teléfono</b> *</label>\n  <div style="position: relative;">\n    <textarea name="Text1" class="w-100" rows="4" minlength="3" maxlength="350" df-numbermessage id="phoneRequestMessage"></textarea>\n<button type="button" class="emoji-toggle emoji-button"><i class="far fa-smile" style="font-size: 20px; pointer-events: none;"></i></button>\n  </div>\n  <span id="phoneRequestMessageError" class="error-message"></span>\n  <span id="phoneRequestMessageCounter" class="character-counter" data-for="phoneRequestMessage"></span>\n  \n  <!-- Mensaje para solicitar correo electrónico -->\n  <label class="form-label">Mensaje para solicitar <b>correo electrónico</b> *</label>\n  <div style="position: relative;">\n    <textarea name="Text1" class="w-100" rows="4" minlength="3" maxlength="350" df-emailmessage id="emailRequestMessage"></textarea>\n<button type="button" class="emoji-toggle emoji-button"><i class="far fa-smile" style="font-size: 20px; pointer-events: none;"></i></button>\n  </div>\n  <span id="emailRequestMessageError" class="error-message"></span>\n  <span id="emailRequestMessageCounter" class="character-counter" data-for="emailRequestMessage"></span>\n  \n  <p class="mt-3">Componente completado <i id="completionIcon" class="fas fa-check-circle fa-lg icon-spaced"></i></p>\n </div>\n</div>\n',
          typenode: false,
          inputs: {
            input_1: {
              connections: [
                {
                  node: '37',
                  input: 'output_1',
                },
              ],
            },
          },
          outputs: {
            output_1: {
              connections: [
                {
                  node: '39',
                  output: 'input_1',
                },
              ],
            },
          },
          pos_x: 669,
          pos_y: 9,
        },
        39: {
          id: 39,
          name: 'MainMenu',
          data: {
            type: 'MAINMENU',
            name: 'Menú principal',
            message: '¿Con qué puedo ayudarte?',
            completed: true,
            isExpanded: true,
            entryType: '',
            options: [
              {
                'opt-40': 'Opción 1',
              },
              {
                'opt-41': 'Opción 2',
              },
            ],
            labelid: '',
          },
          class: 'beplic-node',
          html: '\n<div class="header-container">\n    <i class="fas fa-bars header-icon"></i> <p class="header-text">menú principal</p>\n    <span id="toggleIcon" class="expand-icon">-</span>\n</div>\n<div id="body-container" class="card">\n    <div class="card-body">\n        <h6 class="mb-3">Configura el menú principal de opciones</h6>\n\n        <!-- Nombre del menú principal -->\n        <label class="form-label">Nombre del menú principal *</label>\n        <input type="text" class="form-input w-100" id="nameMainMenu" minlength="3" maxlength="100" df-name>\n        <span id="nameMainMenuError" class="error-message"></span>\n        <span id="nameMainMenuCounter" class="character-counter" data-for="nameMainMenu"></span>\n\n        <!-- Mensaje del menú principal -->\n        <label class="form-label">Mensaje del menú principal *</label>\n        <div style="position: relative;">\n            <textarea name="messageMainMenu" class="w-100" rows="4" minlength="3" maxlength="300" df-message id="messageMainMenu"></textarea>\n<button type="button" class="emoji-toggle emoji-button"><i class="far fa-smile" style="font-size: 20px; pointer-events: none;"></i></button>\n        </div>\n        <span id="messageMainMenuError" class="error-message"></span>\n        <span id="messageMainMenuCounter" class="character-counter" data-for="messageMainMenu"></span>\n\n        <span>Los elementos conectados formarán parte del menú principal como opciones a elegir</span>\n        <p class="mt-3">Componente completado <i id="completionIcon" class="fas fa-check-circle fa-lg icon-spaced"></i></p>\n    </div>\n</div>\n',
          typenode: false,
          inputs: {
            input_1: {
              connections: [
                {
                  node: '38',
                  input: 'output_1',
                },
              ],
            },
          },
          outputs: {
            output_1: {
              connections: [
                {
                  node: '40',
                  output: 'input_1',
                },
                {
                  node: '41',
                  output: 'input_1',
                },
              ],
            },
          },
          pos_x: 1106,
          pos_y: 185,
        },
        40: {
          id: 40,
          name: 'Option',
          data: {
            type: 'OPTION',
            name: 'Opción 1',
            message: 'Compras',
            completed: true,
            isExpanded: true,
            entryType: '',
            labelid: '',
          },
          class: 'beplic-node',
          html: '\n        <div class="header-container">\n            <i class="fas fa-arrow-right header-icon"></i> <p class="header-text">opción</p>\n            <span id="toggleIcon" class="expand-icon">-</span>\n        </div>\n        <div id="body-container" class="card">\n            <div class="card-body">\n                <h6 class="mb-3">Configura la opción del menú</h6> \n                \n                <!-- Nombre del componente opción -->\n                <label class="form-label">Nombre del componente opción *</label>\n                <input type="text" class="form-input w-100" id="nameOption" minlength="3" maxlength="70" df-name>\n                <span id="nameOptionError" class="error-message"></span>\n                <span id="nameOptionCounter" class="character-counter" data-for="nameOption"></span>\n                \n                <!-- Opción de menú -->\n                <label class="form-label">Opción de menú *</label>\n                <input type="text" class="form-input w-100" id="messageOption" minlength="3" maxlength="70" df-message>\n                <span id="messageOptionError" class="error-message"></span>\n                <span id="messageOptionCounter" class="character-counter" data-for="messageOption"></span>\n                \n                <p class="mt-3">Componente completado <i id="completionIcon" class="fas fa-check-circle fa-lg icon-spaced"></i></p>\n            </div>\n        </div>\n    ',
          typenode: false,
          inputs: {
            input_1: {
              connections: [
                {
                  node: '39',
                  input: 'output_1',
                },
              ],
            },
          },
          outputs: {
            output_1: {
              connections: [
                {
                  node: '42',
                  output: 'input_1',
                },
              ],
            },
          },
          pos_x: 1529,
          pos_y: -32,
        },
        41: {
          id: 41,
          name: 'Option',
          data: {
            type: 'OPTION',
            name: 'Opción 2',
            message: 'Pedidos',
            completed: true,
            isExpanded: true,
            entryType: '',
            labelid: '',
          },
          class: 'beplic-node',
          html: '\n        <div class="header-container">\n            <i class="fas fa-arrow-right header-icon"></i> <p class="header-text">opción</p>\n            <span id="toggleIcon" class="expand-icon">-</span>\n        </div>\n        <div id="body-container" class="card">\n            <div class="card-body">\n                <h6 class="mb-3">Configura la opción del menú</h6> \n                \n                <!-- Nombre del componente opción -->\n                <label class="form-label">Nombre del componente opción *</label>\n                <input type="text" class="form-input w-100" id="nameOption" minlength="3" maxlength="70" df-name>\n                <span id="nameOptionError" class="error-message"></span>\n                <span id="nameOptionCounter" class="character-counter" data-for="nameOption"></span>\n                \n                <!-- Opción de menú -->\n                <label class="form-label">Opción de menú *</label>\n                <input type="text" class="form-input w-100" id="messageOption" minlength="3" maxlength="70" df-message>\n                <span id="messageOptionError" class="error-message"></span>\n                <span id="messageOptionCounter" class="character-counter" data-for="messageOption"></span>\n                \n                <p class="mt-3">Componente completado <i id="completionIcon" class="fas fa-check-circle fa-lg icon-spaced"></i></p>\n            </div>\n        </div>\n    ',
          typenode: false,
          inputs: {
            input_1: {
              connections: [
                {
                  node: '39',
                  input: 'output_1',
                },
              ],
            },
          },
          outputs: {
            output_1: {
              connections: [
                {
                  node: '43',
                  output: 'input_1',
                },
              ],
            },
          },
          pos_x: 1542,
          pos_y: 414,
        },
        42: {
          id: 42,
          name: 'Message',
          data: {
            type: 'MESSAGE',
            name: 'Mensaje 1',
            message: '¡Genial! Seleccionaste Compras.',
            response: false,
            completed: true,
            isExpanded: true,
            entryType: '',
            labelid: '',
          },
          class: 'beplic-node',
          html: '\n      <div class="header-container">\n            <i class="fas fa-comments header-icon"></i> <p class="header-text">mensaje</p>\n            <span id="toggleIcon" class="expand-icon">-</span>\n        </div>\n      <div id="body-container" class="card">\n          <div class="card-body message-node-undefined">\n              <h6 class="mb-3">Configura el mensaje que deseas enviar a tus destinatarios</h6>\n              <label class="form-label">Nombre del componente mensaje</label>\n              <input type="text" class="form-input w-100" id="nameMessage" minlength="3" maxlength="70" df-name>\n              <span id="nameMessageError" class="error-message"></span>\n              <span id="nameMessageCounter" class="character-counter" data-for="nameMessage"></span>\n              <label class="form-label">Mensaje a enviar</label>\n              <div style="position: relative;">\n                  <textarea name="Text1" class="w-100" id="messageMessage" rows="5" minlength="3" maxlength="2000" df-message></textarea>\n<button type="button" class="emoji-toggle emoji-button"><i class="far fa-smile" style="font-size: 20px; pointer-events: none;"></i></button>\n              </div>\n              <span id="messageMessageError" class="error-message"></span>\n              <span id="messageMessageCounter" class="character-counter" data-for="messageMessage"></span>\n              <label class="form-label form-label-check">\n                  Esperar respuesta\n                  <input type="checkbox" class="form-checkbox response-checkbox-undefined" df-response>\n              </label>\n              <p class="mt-3">Componente completado <i class="fas fa-check-circle fa-lg icon-spaced" id="completionIcon"></i></p>\n          </div>\n      </div>\n  ',
          typenode: false,
          inputs: {
            input_1: {
              connections: [
                {
                  node: '40',
                  input: 'output_1',
                },
              ],
            },
          },
          outputs: {
            output_1: {
              connections: [
                {
                  node: '44',
                  output: 'input_1',
                },
              ],
            },
          },
          pos_x: 2055,
          pos_y: -222,
        },
        43: {
          id: 43,
          name: 'Message',
          data: {
            type: 'MESSAGE',
            name: 'Mensaje 2',
            message: '¡Perfecto! Seleccionaste Pedidos.',
            response: true,
            completed: true,
            isExpanded: true,
            entryType: '',
            labelid: '',
          },
          class: 'beplic-node',
          html: '\n      <div class="header-container">\n            <i class="fas fa-comments header-icon"></i> <p class="header-text">mensaje</p>\n            <span id="toggleIcon" class="expand-icon">-</span>\n        </div>\n      <div id="body-container" class="card">\n          <div class="card-body message-node-undefined">\n              <h6 class="mb-3">Configura el mensaje que deseas enviar a tus destinatarios</h6>\n              <label class="form-label">Nombre del componente mensaje</label>\n              <input type="text" class="form-input w-100" id="nameMessage" minlength="3" maxlength="70" df-name>\n              <span id="nameMessageError" class="error-message"></span>\n              <span id="nameMessageCounter" class="character-counter" data-for="nameMessage"></span>\n              <label class="form-label">Mensaje a enviar</label>\n              <div style="position: relative;">\n                  <textarea name="Text1" class="w-100" id="messageMessage" rows="5" minlength="3" maxlength="2000" df-message></textarea>\n<button type="button" class="emoji-toggle emoji-button"><i class="far fa-smile" style="font-size: 20px; pointer-events: none;"></i></button>\n              </div>\n              <span id="messageMessageError" class="error-message"></span>\n              <span id="messageMessageCounter" class="character-counter" data-for="messageMessage"></span>\n              <label class="form-label form-label-check">\n                  Esperar respuesta\n                  <input type="checkbox" class="form-checkbox response-checkbox-undefined" df-response>\n              </label>\n              <p class="mt-3">Componente completado <i class="fas fa-check-circle fa-lg icon-spaced" id="completionIcon"></i></p>\n          </div>\n      </div>\n  ',
          typenode: false,
          inputs: {
            input_1: {
              connections: [
                {
                  node: '41',
                  input: 'output_1',
                },
              ],
            },
          },
          outputs: {
            output_1: {
              connections: [
                {
                  node: '44',
                  output: 'input_1',
                },
              ],
            },
          },
          pos_x: 2067,
          pos_y: 436,
        },
        44: {
          id: 44,
          name: 'End',
          data: {
            type: 'END',
            name: 'Fin 1',
            message: 'Gracias por contactarnos.',
            completed: true,
            isExpanded: true,
            entryType: '',
            labelid: '',
          },
          class: 'beplic-node',
          html: '\n<div class="header-container">\n<i class="fas fa-award header-icon"></i> <p class="header-text">fin del flujo</p>\n<span id="toggleIcon" class="expand-icon">-</span>\n</div>\n<div id="body-container" class="card">\n<div class="card-body">\n <h6 class="mb-3">El componente FIN sirve para finalizar el flujo de conversación</h6>\n <label class="form-label">Mensaje de despedida o finalización *</label>\n <div style="position: relative;">\n     <textarea name="Text1" class="w-100" rows="5" minlength="3" maxlength="700" df-message ></textarea>\n<button type="button" class="emoji-toggle emoji-button"><i class="far fa-smile" style="font-size: 20px; pointer-events: none;"></i></button>\n </div>\n <span id="finMessageError" class="error-message"></span>\n <span id="finMessageCounter" class="character-counter" data-for="finMessage"></span>\n <p class="mt-3">Componente completado <i id="completionIcon" class="fas fa-check-circle fa-lg icon-spaced"></i></p>\n</div>\n</div>\n',
          typenode: false,
          inputs: {
            input_1: {
              connections: [
                {
                  node: '43',
                  input: 'output_1',
                },
                {
                  node: '42',
                  input: 'output_1',
                },
              ],
            },
          },
          outputs: {},
          pos_x: 2576,
          pos_y: 358,
        },
      },
    },
  },
};
